var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-chapter"},[_c('WsUpdateMultiLayer',{attrs:{"modelName":_vm.modelName,"title":_vm.title,"label":_vm.label,"layersSetting":_vm.layersSetting,"getUrl":_vm.$_getUrl,"getPayload":_vm.$_getPayload}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }